module.exports = __webpack_public_path__ + "img/fondo0.9089e7ad.jpg";